import { 
	Checkbox,
	Divider,
	Flex,
	Icon,
	IconButton,
	Image,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Stack,
	Text,
	useBreakpointValue
} from '@chakra-ui/react';
import { FiCheckCircle, FiMoreVertical } from 'react-icons/fi';

import { useAuth } from '../../../hooks/auth';
import { FinJsonDTO } from '../../../dtos/FinJsonDTO';
import ImpressaoLancamento from '../ImpressaoLancamento';

type TextAlertData = {
	header: string;
	body: string;
	is_toast: boolean;
}
type LancamentoData = {
	caixa: string;
	compensado: boolean;
	data: string;
	doc: string;
	fin_json: FinJsonDTO;
	id_lancamento: string;
	name_pay: string;
	nome: string;
	operacao: string;
	operacao_tipo: string;
	url_pay: string;
	vlr_cred: number;
	vlr_cred_formatted?: string;
	vlr_deb: number;
	vlr_deb_formatted?: string;
};
interface DTCardsParams {
	lancamentos: LancamentoData[];
	setLancamentoModal: (lancamento: FinJsonDTO) => void;
	setModalLancamentoVisible: (open: boolean) => void;
	setModalLancamentoEditVisible: (open: boolean) => void;
	setLancamentoDelete: (lanc: FinJsonDTO) => void;
	setOpenAlert: (open: boolean) => void;
	setTextAlert: (texts: TextAlertData) => void;
};

const DTCards: React.FC<DTCardsParams> = ({
	lancamentos,
	setLancamentoModal,
	setModalLancamentoVisible,
	setModalLancamentoEditVisible,
	setLancamentoDelete,
	setOpenAlert,
	setTextAlert,
}) => {
	const { permissions } = useAuth();

	const isWideVersion = useBreakpointValue({
		base: false,
		lg: true,
	});

  return (
    <Flex w="100%" flexDir="column" justify="center" align="center">
      {lancamentos.map(lancamento => {
        return (
          <Flex
						key={lancamento.id_lancamento}
            w="100%"
            bgGradient="linear(to-r, gray.50, gray.100)"
            borderRadius={8}
            boxShadow="xl"
            p="4"
						pr="2"
						m={["2", "4"]}
          >
						<Flex w="100%">
							<Flex w="100%">
								<Flex flexDir="column" w="90%">
									{/* NOME */}
									<Flex w="100%">
										<Text
											color="blue.500"
											textTransform="uppercase"
											fontWeight="500"
											fontSize={[14, 15]}
										>
											{lancamento.nome === '' ? '--' : lancamento.nome}
										</Text>
									</Flex>

									{/* DOCUMENTO */}
									<Flex w="100%" mt={1}>
										<Text color="gray.500" fontSize={[13, 15]} fontWeight={500}>
											Documento:
										</Text>
										&nbsp;
										<Text color="gray.800" fontWeight="500" fontSize={[13, 15]}>
											{lancamento.doc}
										</Text>
									</Flex>

									{/* PAGTO - CONTA */}
									<Flex flexDir={["column", "row"]} justify={["flex-start", "space-between"]} mt={1}>
										{/* PAGTO */}
										<Flex w="100%">
											<Text color="gray.500" fontSize={[13, 15]} fontWeight={500}>
												Pagto:
											</Text>&nbsp;
											{lancamento.url_pay && (
												<Image src={lancamento.url_pay} objectFit='cover' w='25px' h="20px" mr={2} />
											)}
											<Text
												color="gray.800"
												fontWeight="500"
												fontSize={[13, 15]}
											>
												{lancamento.name_pay}
											</Text>
										</Flex>
										{/* CONTA */}
										<Flex w="100%">
											<Text color="gray.500" fontSize={[13, 15]} fontWeight={500}>Conta: </Text>
												&nbsp;
											<Text
												color="gray.800"
												fontWeight="500"
												fontSize={[13, 15]}
											>
												{lancamento.name_pay}
											</Text>
										</Flex>
									</Flex>

									{/* COMPENSADO - DATA */}
									<Flex flexDir={["column", "row"]} justify={["flex-start", "space-between"]} mt={1}>
										{/* COMPENSADO */}
										<Flex w="100%">
											<Text color="gray.500" fontSize={[13, 15]} fontWeight={500}>
												Compensado:
											</Text>&nbsp;
											{lancamento.compensado
												? <Icon as={FiCheckCircle} fontSize={18} color="blue.500" />
												: '--'
											}
										</Flex>
										{/* DATA */}
										<Flex w="100%">
											<Text color="gray.500" fontSize={[13, 15]} fontWeight={500}>Data: </Text>
											&nbsp;
											<Text
												color="gray.800"
												fontWeight="500"
												fontSize={[13, 15]}
											>
												{lancamento.data}
											</Text>
										</Flex>
									</Flex>

									{/* OPERAÇÂO - TIPO OPERAÇÃO */}
									<Flex flexDir={["column", "row"]} justify={["flex-start", "space-between"]} mt={1}>
										{/* OPERAÇÂO */}
										<Flex  w="100%">
											<Text color="gray.500" fontSize={[13, 15]} fontWeight={500}>Operação: </Text>
											&nbsp;
											<Text
												color="gray.800"
												fontWeight="500"
												fontSize={[13, 15]}
											>
												{lancamento.operacao}
											</Text>
										</Flex>
										{/* TIPO OPERAÇÃO */}
										<Flex  w="100%">
											<Text color="gray.500" fontSize={[13, 15]} fontWeight={500}>Tipo Operação: </Text>
											&nbsp;
											<Text
												color="gray.800"
												fontWeight="500"
												fontSize={[13, 15]}
											>
												{lancamento.operacao_tipo}
											</Text>
										</Flex>
									</Flex>

									{/* VLR_CRED - VLR_DEB */}
									<Flex w="100%">
										{/* VLR CRED */}
										<Flex fontSize={[13, 15]} fontWeight={500} color="gray.600" w="100%" py={2}>
											<Text>Vlr Créd:</Text>&nbsp;
											<Text color="gray.800">{lancamento.vlr_cred_formatted}</Text>
										</Flex>
										{/* VLR DEB  */}
										<Flex justify="space-between" align="center" w="100%">
											<Flex fontSize={[13, 15]} fontWeight={500} color="gray.600" w="100%">
												<Text>Vlr Déb:</Text>&nbsp;
												<Text color="gray.800">{lancamento.vlr_deb_formatted}</Text>
											</Flex>
										</Flex>
									</Flex>
								</Flex>

								{/* MENU */}
								<Flex flexDir="column" justify="flex-end">
									<Flex>
										<ImpressaoLancamento lancamento={lancamento.fin_json} />
										
										<Menu>
											{({ isOpen }) => (
												<>
													<MenuButton
														border={0}
														fontSize="1.5626rem"
														as={IconButton}
														isActive={isOpen}
														aria-label="Options"
														icon={<FiMoreVertical />}
														variant="outline"
															_hover={{ bg: isWideVersion ? "gray.50" : "gray.100"}}
													/>

													<MenuList p={0} boxShadow='xl'>
														<MenuItem
															fontSize={16}
															fontWeight={500}
															py={3}
															_hover={{ bg: 'gray.50' }}
															onClick={() => {
																setLancamentoModal(lancamento.fin_json);
																setModalLancamentoVisible(true);
															}}
														>
															Detalhes
														</MenuItem>

														{permissions.alterar && (
															<>
																<Divider />

																<MenuItem
																	fontSize={16}
																	fontWeight={500}
																	py={3}
																	_hover={{ bg: 'gray.50' }}
																	onClick={() => {
																		setLancamentoModal(lancamento.fin_json);
																		setModalLancamentoEditVisible(true);
																	}}
																>
																	Editar
																</MenuItem>
															</>
														)}

														{permissions.excluir && (
															<>
																<Divider />

																<MenuItem
																	fontSize={16}
																	fontWeight={500}
																	py={3}
																	_hover={{ bg: 'gray.50' }}
																	isDisabled
																	onClick={() => {
																		setLancamentoDelete(lancamento.fin_json);
																		setTextAlert({
																			header: `Excluir Lançamento!`,
																			body: 'Você está excluindo este lançamento!' + "\n" + 'Deseja mesmo excluir?',
																			is_toast: true,
																		});
																		setOpenAlert(true);
																	}}
																>
																	Excluir
																</MenuItem>
															</>
														)}
													</MenuList>
												</>
											)}
										</Menu>
									</Flex>
								</Flex>
              </Flex>
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};

export default DTCards;
